var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.8 24.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 8,
    width: 5.1,
    height: 16.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9,5.8A2.9,2.9,0,1,1,5.8,2.9,2.68,2.68,0,0,1,2.9,5.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,24.6H19.7v-8c0-2,0-4.4-2.7-4.4s-3.1,2-3.1,4.2v8.2H8.8V8h4.9v2.2h0a5.5,5.5,0,0,1,4.9-2.7c5.3,0,6.2,3.5,6.2,7.8v9.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7cc1dd100080e0828c6015ff0fb0fe5e.svg";
export { ForwardRef as ReactComponent };